import React, { Component } from "react";
import { PropTypes } from "prop-types";
import { connect } from "react-redux";
import t from "@zendesk/client-i18n-tools";
import { Pagination } from "@zendeskgarden/react-pagination";
import { Droppable, Draggable } from "react-beautiful-dnd";
import ArticleRow from "../ArticleRow";
import * as sectionActions from "../../actions/section";
import styles from "./index.css";

export class ArticleList extends Component {
  constructor(props) {
    super(props);

    this.onArticleMoveTo = this.onArticleMoveTo.bind(this);
  }

  onArticleMoveTo(articleId, destinationOption, sourceIndex) {
    const { dispatch } = this.props;
    const {
      id: destinationOptionId,
      type: destinationOptionType,
    } = destinationOption;

    destinationOptionType === "Section" &&
      dispatch(
        sectionActions.moveArticleToSection(
          articleId,
          destinationOptionId,
          sourceIndex
        )
      );
  }

  renderArticles() {
    const {
      articles,
      isFetching,
      pageCount,
      page,
      onPageSelected,
      isMoving,
      articleSavingId,
      articleSuccessId,
      onMoveToTop,
    } = this.props;

    if (isFetching) {
      return null;
    }

    const pagination = pageCount > 1 && (
      <div data-test-id="articles-pagination">
        <Pagination
          totalPages={pageCount}
          currentPage={page}
          onChange={onPageSelected}
        />
      </div>
    );

    return (
      <div>
        <div className={styles.list}>
          {articles.map((article, index) => (
            <Draggable
              key={article.id}
              draggableId={article.id}
              index={index}
              type="article"
              isDragDisabled={isMoving}
            >
              {(provided, snapshot) => (
                <ArticleRow
                  testId="article-item"
                  key={article.id}
                  onMoveToTop={() => onMoveToTop(article, index)}
                  saving={articleSavingId === article.id}
                  success={articleSuccessId === article.id}
                  article={article}
                  dragging={snapshot.isDragging}
                  dragHandleProps={provided.dragHandleProps}
                  dragRef={provided.innerRef}
                  dragProps={provided.draggableProps}
                  onMoveTo={destinationSection =>
                    this.onArticleMoveTo(article.id, destinationSection, index)
                  }
                />
              )}
            </Draggable>
          ))}
        </div>
        {pagination}
      </div>
    );
  }

  render() {
    const { count } = this.props;

    if (count === 0) {
      return null;
    }

    return (
      <div className={styles.container}>
        <h3 className={styles.listHeader}>
          {t("knowledge-arrange.articles.pageTitle", { count })}
        </h3>

        <Droppable droppableId="articles" type="article">
          {(provided, snapshot) => (
            <div ref={provided.innerRef} {...provided.droppableProps}>
              {this.renderArticles()}
            </div>
          )}
        </Droppable>
      </div>
    );
  }
}

ArticleList.propTypes = {
  articles: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired,
      html_url: PropTypes.string.isRequired,
    })
  ).isRequired,
  dispatch: PropTypes.func.isRequired,
  count: PropTypes.number.isRequired,
  isFetching: PropTypes.bool.isRequired,
  isMoving: PropTypes.bool.isRequired,
  pageCount: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  onPageSelected: PropTypes.func,
  articleSavingId: PropTypes.number,
  articleSuccessId: PropTypes.number,
  onMoveToTop: PropTypes.func,
};

const mapStateToProps = ({ articles }) => {
  return {
    articles: articles.list,
    isFetching: articles.isFetching,
    pageCount: articles.pageCount,
    isMoving: articles.isMoving,
    articleSavingId: articles.savingId,
    articleSuccessId: articles.successId,
  };
};

export default connect(mapStateToProps)(ArticleList);



// WEBPACK FOOTER //
// ./src/components/ArticleList/index.js